
// initial state
const state = {
    column_switch:null,
    vcg_token:null,
}

// getters
const getters = {
    column_switch:state=>state.column_switch,
    vcg_token:state=>state.vcg_token,
}

// actions
const actions = {
    set_column_switch_action({commit},data){
        commit("set_column_switch_mutation",data)
    },
    set_vcg_token_action({commit},data){
        commit("set_vcg_token_mutation",data)
    }
}
// mutations
const mutations = {
    set_column_switch_mutation(state,data){
        state.column_switch = data;
    },
    set_vcg_token_mutation(state,data){
        state.vcg_token = data;
    }
}
export default {
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/publicinfo.js